import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalFolderActions as Internal,
} from '../../actions'

export function* rename({
  payload: { workspaceId, id, title },
}: ReturnType<typeof DashboardActions.folders.rename>) {
  yield put(Internal.update({ id, workspaceId, data: { title } }))

  yield call(NestClient.folders.rename, workspaceId, { id, title })
}
